<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .dropdowns {
    display: grid;
    position: relative;
    gap: utils.in_rem(10px);
  }
</style>

<script>
  import { integrationStore } from "../../stores";
  import Accordion from "./Accordion.svelte";
  import SettingDropdown from "./SettingDropdown.svelte";
  import SettingMultiDropdown from "./SettingMultiDropdown.svelte";
  import SettingToggle from "./SettingToggle.svelte";

  export let type;
  export let section = "contactAdvanced";
  let isExpanded = false;

  $: toggleSettings = $integrationStore
    .getSettings(section, type || undefined)
    .filter((setting) => setting.kind === "checkbox");

  $: singleChoiceSettings = $integrationStore
    .getSettings(section, type || undefined)
    .filter((s) => s.kind === "singleChoice");

  $: multiChoiceSettings = $integrationStore
    .getSettings(section, type || undefined)
    .filter((s) => s.kind === "multiChoice");
</script>

{#if toggleSettings.length || (singleChoiceSettings.length && singleChoiceSettings.some((s) => s.values.length)) || (multiChoiceSettings.length && multiChoiceSettings.some((s) => s.values.length))}
  <Accordion bind:isExpanded headerText="Advanced Settings">
    {#each toggleSettings as setting (setting.key)}
      <SettingToggle {setting} {...type ? { type } : {}} />
    {/each}

    <div class="dropdowns">
      {#each singleChoiceSettings as setting}
        <SettingDropdown {setting} {...type ? { type } : {}} />
      {/each}

      {#each multiChoiceSettings as setting}
        <SettingMultiDropdown {setting} {...type ? { type } : {}} />
      {/each}
    </div>
  </Accordion>
{/if}
